import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {Globals}  from './Globals'
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import storage from 'local-storage-fallback';

@Injectable()
export class ClientRequest {
  constructor(private router: Router, private http: HttpClient, public global: Globals) {}
  createAuthorizationHeader() {
    let headers: HttpHeaders = new HttpHeaders();
    let token = this.global.token ? this.global.token : storage.getItem("token");
    headers = headers.append('Authorization', 'Bearer ' + token);
    if(this.global.wid) headers = headers.append('wid', this.global.wid);
    return headers;
  }

  get(url, data=null) {
    return this.http.get(this.global.apiEndpoint + url, {headers: this.createAuthorizationHeader(), params: data})
    .catch((err: HttpErrorResponse) => {
      if(err.status===0) this.router.navigate(['/error/network']);
      else if(err.status===404) this.router.navigate(['/error/404']);
      else if(err.status===401) this.router.navigate(['/auth/login']);
      return Observable.throw(err.statusText);
    });
  }

  post(url, data) {
    return this.http.post(this.global.apiEndpoint + url, data, {headers: this.createAuthorizationHeader()});
  }
}